export default __webpack_public_path__ + "static/media/300-600.24e77b6c.png";